import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _AddContentBody;
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import first from 'lodash/first';
import { IconBankLine } from '@instructure/ui-icons';
import { IconButton } from '@instructure/ui-buttons';
import { Grid } from '@instructure/ui-grid';
import { View } from '@instructure/ui-view';
import { Text } from '@instructure/ui-text';
import { jsx } from '@instructure/emotion';
import InteractionTypes from '../../../../shared/InteractionTypes';
import t from '@instructure/quiz-i18n/es/format-message';
import { BUILD_TRAY_OPEN, BUILD_TRAY_POSITION, BUILD_TRAY_STIMULUS_ID, withStyleOverrides } from '@instructure/quiz-common';
import generateStyle from './styles';
import generateComponentTheme from './theme';
export var AddContentBody = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_AddContentBody = /*#__PURE__*/function (_Component) {
  function AddContentBody() {
    var _this;
    _classCallCheck(this, AddContentBody);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, AddContentBody, [].concat(args));
    // ==============================
    // ACTIONS
    // ==============================
    _defineProperty(_this, "openBankTray", function () {
      _this.props.onOpenBankTray();
      _this.props.setUi(BUILD_TRAY_OPEN, true);
      _this.props.setUi(BUILD_TRAY_POSITION, _this.props.position);
      _this.props.setUi(BUILD_TRAY_STIMULUS_ID, _this.props.parentEntryId);
    });
    _defineProperty(_this, "addStimulus", function (isPassage) {
      if (_this.props.editingQuizEntry) {
        _this.props.setNextQuizEntry(null, _this.props.quizId, _this.props.position);
      } else {
        _this.props.createStimulus(_this.props.quizId, _this.props.position, isPassage);
      }
      _this.props.onAddItem();
    });
    _defineProperty(_this, "addItem", function (interactionTypeData) {
      if (_this.props.quizEntryWithErrorsShowing) {
        _this.props.screenreaderNotification(t('Question {itemPosition, number} cannot be saved due to invalid input data', {
          itemPosition: Math.ceil(_this.props.quizEntryWithErrorsShowing.position)
        }));
      } else {
        var _this$props = _this.props,
          quizId = _this$props.quizId,
          position = _this$props.position,
          stimulusId = _this$props.stimulusId,
          parentEntryId = _this$props.parentEntryId;
        if (_this.props.editingQuizEntry) {
          _this.props.setNextQuizEntry(interactionTypeData, quizId, position, stimulusId, parentEntryId);
        } else {
          var defaultInteractionData = interactionTypeData.getDefaultInteractionData();
          var scoringData = interactionTypeData.getDefaultScoringData(defaultInteractionData);
          _this.props.createItem(quizId, position, {
            id: interactionTypeData.id,
            interactionData: defaultInteractionData,
            itemBody: interactionTypeData.itemBody,
            properties: interactionTypeData.defaultProperties,
            scoringAlgorithm: interactionTypeData.scoringAlgorithmDefault,
            scoringData: scoringData,
            userResponseType: first(interactionTypeData.userResponseTypeOptions)
          }, parentEntryId, stimulusId);
        }
      }
      _this.props.onAddItem();
    });
    // ==============================
    // RENDERING
    // ==============================
    _defineProperty(_this, "renderBankButton", function () {
      return jsx(IconButton, {
        size: "large",
        onClick: _this.openBankTray,
        "data-automation": "sdk-add-banked-content-button",
        screenReaderLabel: t('Add banked content')
      }, jsx(IconBankLine, null));
    });
    _defineProperty(_this, "renderPopoverHeader", function () {
      var text = _this.props.showHeaderText ? t('Insert Content') : '';
      return jsx("div", {
        css: _this.props.styles.popoverHeaderBox
      }, jsx("div", {
        css: _this.props.styles.popoverHeader
      }, jsx(Grid, {
        vAlign: "middle",
        colSpacing: "none",
        rowSpacing: "none"
      }, jsx(Grid.Row, null, jsx(Grid.Col, null, jsx(Text, {
        color: "primary"
      }, text)), jsx(Grid.Col, {
        width: "auto"
      }, _this.renderBankButton())))));
    });
    return _this;
  }
  _inherits(AddContentBody, _Component);
  return _createClass(AddContentBody, [{
    key: "render",
    value: function render() {
      return jsx("div", {
        css: this.props.styles.popoverContent,
        role: "dialog",
        "aria-label": t('Insert Content')
      }, this.renderPopoverHeader(), jsx(View, {
        padding: "small"
      }, jsx(InteractionTypes, {
        columns: 2,
        addItem: this.addItem,
        addStimulus: this.addStimulus,
        allowStimulusCreation: this.props.allowStimulusCreation,
        types: this.props.interactionTypes
      })));
    }
  }]);
}(Component), _defineProperty(_AddContentBody, "displayName", 'AddContentBody'), _defineProperty(_AddContentBody, "componentId", "Quizzes".concat(_AddContentBody.displayName)), _defineProperty(_AddContentBody, "propTypes", {
  allowStimulusCreation: PropTypes.bool.isRequired,
  createItem: PropTypes.func.isRequired,
  createStimulus: PropTypes.func.isRequired,
  editingQuizEntry: PropTypes.bool,
  interactionTypes: ImmutablePropTypes.list,
  onOpenBankTray: PropTypes.func,
  onAddItem: PropTypes.func,
  parentEntryId: PropTypes.string,
  position: PropTypes.number.isRequired,
  quizEntryWithErrorsShowing: ImmutablePropTypes.record,
  quizId: PropTypes.string.isRequired,
  screenreaderNotification: PropTypes.func.isRequired,
  setNextQuizEntry: PropTypes.func.isRequired,
  setUi: PropTypes.func.isRequired,
  showHeaderText: PropTypes.bool,
  stimulusId: PropTypes.string,
  styles: PropTypes.object
}), _defineProperty(_AddContentBody, "defaultProps", {
  editingQuizEntry: void 0,
  interactionTypes: void 0,
  onAddItem: Function.prototype,
  parentEntryId: void 0,
  onOpenBankTray: Function.prototype,
  quizEntryWithErrorsShowing: void 0,
  showHeaderText: true,
  stimulusId: void 0
}), _AddContentBody)) || _class);
export default AddContentBody;